import {post} from '@/utils/request';


//登录
export async function getlogin(params) {
    return post('/login/validate', params, true);
    // return post('http://test.m.ghwline.com/login/validate', params, true);

}
//获取验证码
export async function getcode(params) {
    return post('/login/sendVerficationCode', params, true)
}
//设置密码
export async function setpwd(params) {
    return post('/login/setPwd', params, true)
}
//验证码success
export async function getvalidatecode(params) {
    return post('/login/validateCode', params, true)
}